export default function (state = null, action) {
    if (action.type === 'STATISTICI') {
        // console.log('reducer', action.payload)
        state = {
            ...action.payload.response,
            extra: action.payload.extra
        }
    }
    return state;
}